import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'components/Modal';
import Landmark from 'components/Landmark';
import { jsx as _jsx } from "react/jsx-runtime";
var TimeZonePicker = /*#__PURE__*/React.lazy(function () {
  return import('./TimeZonePicker');
});
function TimeZonePickerModal(_ref) {
  var selected = _ref.selected,
    onSubmit = _ref.onSubmit,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx(Modal, {
    id: "time-zones-picker-modal",
    "aria-label": t('actions_select_timezone'),
    onRequestClose: onClose,
    children: /*#__PURE__*/_jsx(Suspense, {
      fallback: /*#__PURE__*/_jsx(Landmark, {
        icon: "spinner"
      }),
      children: /*#__PURE__*/_jsx(TimeZonePicker, {
        selected: selected,
        onSubmit: onSubmit,
        onClose: onClose
      })
    })
  });
}
export default TimeZonePickerModal;